var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.81;fill:#5E8FBD;enable-background:new    ;}\n\t.st1{opacity:0.81;fill:#5E90BD;enable-background:new    ;}\n\t.st2{opacity:0.86;fill:#5C94C8;enable-background:new    ;}\n\t.st3{opacity:0.72;fill:#6C8DAD;enable-background:new    ;}\n\t.st4{opacity:0.67;fill:#6685A0;enable-background:new    ;}\n\t.st5{opacity:0.8;fill:#7098BE;enable-background:new    ;}\n\t.st6{opacity:0.65;fill:#65829D;enable-background:new    ;}\n\t.st7{opacity:0.84;fill:#729EC6;enable-background:new    ;}\n\t.st8{opacity:0.69;fill:#6888A5;enable-background:new    ;}\n\t.st9{opacity:0.76;fill:#6E93B6;enable-background:new    ;}\n\t.st10{opacity:0.87;fill:#71A2CD;enable-background:new    ;}\n\t.st11{opacity:0.64;fill:#627F98;enable-background:new    ;}\n\t.st12{opacity:0.88;fill:#71A2D0;enable-background:new    ;}\n\t.st13{opacity:0.74;fill:#6D91B1;enable-background:new    ;}\n\t.st14{opacity:0.71;fill:#698BA9;enable-background:new    ;}\n\t.st15{opacity:0.81;fill:#709AC1;enable-background:new    ;}\n\t.st16{opacity:0.81;fill:#4683BB;enable-background:new    ;}\n\t.st17{opacity:0.91;fill:#6EA5D6;enable-background:new    ;}\n\t.st18{opacity:0.84;fill:#5990C2;enable-background:new    ;}\n\t.st19{fill:#2285DF;}\n\t.st20{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x23_5e8fbdce"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,0.1h0.4C23.2,0.2,23.1,0.3,23,0.1L23,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,23L0.1,23c0.1,0.1,0.1,0.2,0,0.3V23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.8,23L47.8,23l0,0.4C47.8,23.2,47.7,23.1,47.8,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,47.8c0.1-0.1,0.3,0,0.4,0L22.9,47.8L22.9,47.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_5e90bdce"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.7,0.1H25l0,0C24.9,0.3,24.8,0.2,24.7,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.1,24.7c0.1,0.1,0.1,0.3,0,0.4l0,0V24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.8,25.1c-0.1-0.1,0-0.3,0-0.4L47.8,25.1L47.8,25.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_5c94c8db"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.8,0.4c0,0,0.1,0,0.1,0C20.9,0.4,20.8,0.4,20.8,0.4L20.8,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.3,20.9c0,0,0-0.1,0.1-0.1C0.4,20.8,0.4,20.9,0.3,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.6,20.8c0,0,0,0.1,0.1,0.1C47.6,20.9,47.6,20.8,47.6,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.1,47.7c0,0,0.1,0,0.1-0.1C27.2,47.6,27.1,47.6,27.1,47.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_6c8dadb8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.2,0.4L27.2,0.4L27.2,0.4C27.2,0.4,27.2,0.4,27.2,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,0.5L20,0.5C20,0.5,19.9,0.5,20,0.5L20,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28,0.5L28,0.5L28,0.5C28.1,0.5,28,0.5,28,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.5,20L0.5,20C0.5,19.9,0.5,20,0.5,20L0.5,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.5,19.9L47.5,19.9L47.5,19.9C47.5,20,47.5,19.9,47.5,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.4,27.2C0.4,27.2,0.4,27.2,0.4,27.2L0.4,27.2L0.4,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.6,27.2C47.6,27.2,47.6,27.2,47.6,27.2L47.6,27.2L47.6,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.5,28C0.5,28,0.5,28.1,0.5,28L0.5,28L0.5,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.5,28.1C47.5,28.1,47.5,28,47.5,28.1L47.5,28.1L47.5,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.9,47.5C19.9,47.5,20,47.5,19.9,47.5L19.9,47.5L19.9,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28,47.5C28,47.5,28.1,47.5,28,47.5L28,47.5L28,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.8,47.6C20.8,47.6,20.8,47.6,20.8,47.6L20.8,47.6L20.8,47.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_6685a0ab"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.3,0.4L20.3,0.4C20.4,0.4,20.3,0.4,20.3,0.4L20.3,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.6,0.4L27.6,0.4L27.6,0.4C27.7,0.4,27.6,0.4,27.6,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.3,4.5C10.4,4.4,10.4,4.4,10.3,4.5C10.4,4.4,10.4,4.4,10.3,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.6,4.4C37.6,4.4,37.6,4.4,37.6,4.4C37.6,4.4,37.6,4.4,37.6,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9,5.4C9,5.4,9.1,5.4,9,5.4C9.1,5.4,9,5.4,9,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.9,5.4C38.9,5.4,39,5.4,38.9,5.4L38.9,5.4L38.9,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.4,9.1C5.4,9,5.4,9,5.4,9.1L5.4,9.1L5.4,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.6,9C42.6,9,42.6,9.1,42.6,9C42.6,9.1,42.6,9,42.6,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.4,10.4C4.4,10.4,4.4,10.4,4.4,10.4C4.4,10.4,4.4,10.4,4.4,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.5,10.3C43.6,10.4,43.6,10.4,43.5,10.3C43.6,10.4,43.6,10.4,43.5,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0.4,20.3L0.4,20.3C0.4,20.3,0.4,20.4,0.4,20.3L0.4,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.6,20.3L47.6,20.3L47.6,20.3C47.6,20.4,47.6,20.3,47.6,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0.4,27.6C0.4,27.6,0.4,27.7,0.4,27.6L0.4,27.6L0.4,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.6,27.7C47.6,27.7,47.6,27.6,47.6,27.7L47.6,27.7L47.6,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4.4,37.6C4.4,37.6,4.4,37.6,4.4,37.6C4.4,37.6,4.4,37.6,4.4,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.5,37.7C43.6,37.6,43.6,37.6,43.5,37.7C43.6,37.6,43.6,37.6,43.5,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.4,38.9C5.4,38.9,5.4,39,5.4,38.9C5.4,39,5.4,38.9,5.4,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.6,39C42.6,39,42.6,38.9,42.6,39C42.6,38.9,42.6,39,42.6,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9,42.6C9,42.6,9.1,42.6,9,42.6C9.1,42.6,9,42.6,9,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.9,42.6C38.9,42.6,39,42.6,38.9,42.6C39,42.6,38.9,42.6,38.9,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.3,43.5C10.4,43.6,10.4,43.6,10.3,43.5C10.4,43.6,10.4,43.6,10.3,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.6,43.6C37.6,43.6,37.6,43.6,37.6,43.6C37.6,43.6,37.6,43.6,37.6,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.3,47.6C20.3,47.6,20.4,47.6,20.3,47.6L20.3,47.6L20.3,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.6,47.6C27.6,47.6,27.7,47.6,27.6,47.6L27.6,47.6L27.6,47.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_7098becb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.4,0.8L18.4,0.8C18.4,0.8,18.4,0.8,18.4,0.8L18.4,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.6,0.8L29.6,0.8L29.6,0.8C29.6,0.8,29.6,0.8,29.6,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.1,0.9L18.1,0.9C18.1,0.9,18.1,0.9,18.1,0.9L18.1,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.9,0.9L29.9,0.9L29.9,0.9C29.9,0.9,29.9,0.9,29.9,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.6,3.1L12.6,3.1C12.6,3.1,12.6,3.1,12.6,3.1L12.6,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.4,3L35.4,3L35.4,3C35.4,3.1,35.4,3.1,35.4,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3.1,12.6L3.1,12.6C3.1,12.6,3.1,12.6,3.1,12.6L3.1,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.9,12.6L44.9,12.6L44.9,12.6C44.9,12.6,44.9,12.6,44.9,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0.9,18.1L0.9,18.1C0.9,18.1,0.9,18.1,0.9,18.1L0.9,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.1,18.1L47.1,18.1L47.1,18.1C47.1,18.1,47.1,18.1,47.1,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0.8,18.4L0.8,18.4C0.8,18.4,0.8,18.4,0.8,18.4L0.8,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.2,18.4L47.2,18.4L47.2,18.4C47.2,18.4,47.2,18.4,47.2,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0.8,29.6C0.8,29.6,0.8,29.6,0.8,29.6L0.8,29.6L0.8,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.2,29.6C47.2,29.6,47.2,29.6,47.2,29.6L47.2,29.6L47.2,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0.9,29.9C0.9,29.9,0.9,29.9,0.9,29.9L0.9,29.9L0.9,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.1,29.9C47.1,29.9,47.1,29.9,47.1,29.9L47.1,29.9L47.1,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3,35.4C3.1,35.4,3.1,35.4,3,35.4L3,35.4L3,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.9,35.4C44.9,35.4,44.9,35.4,44.9,35.4L44.9,35.4L44.9,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.6,44.9C12.6,44.9,12.6,44.9,12.6,44.9L12.6,44.9L12.6,44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.4,45C35.4,44.9,35.4,44.9,35.4,45L35.4,45L35.4,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.1,47.1C18.1,47.1,18.1,47.1,18.1,47.1L18.1,47.1L18.1,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.9,47.1C29.9,47.1,29.9,47.1,29.9,47.1L29.9,47.1L29.9,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.4,47.2C18.4,47.2,18.4,47.2,18.4,47.2L18.4,47.2L18.4,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.6,47.2C29.6,47.2,29.6,47.2,29.6,47.2L29.6,47.2L29.6,47.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_65829da7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M17.8,1L17.8,1C17.9,1,17.8,1,17.8,1L17.8,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.1,1L30.1,1L30.1,1C30.2,1,30.1,1,30.1,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.1,1.5L16.1,1.5C16.2,1.5,16.1,1.5,16.1,1.5L16.1,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.8,1.5L31.8,1.5L31.8,1.5C31.9,1.5,31.8,1.5,31.8,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M9.9,4.8C9.9,4.8,9.9,4.8,9.9,4.8C9.9,4.8,9.9,4.8,9.9,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.1,4.8C38.1,4.8,38.1,4.8,38.1,4.8C38.1,4.8,38.1,4.8,38.1,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M4.8,9.9C4.8,9.9,4.8,9.9,4.8,9.9C4.8,9.9,4.8,9.9,4.8,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.2,9.9C43.2,9.9,43.2,9.9,43.2,9.9C43.2,9.9,43.2,9.9,43.2,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1.5,16.1L1.5,16.1C1.5,16.1,1.5,16.2,1.5,16.1L1.5,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.5,16.1L46.5,16.1L46.5,16.1C46.5,16.2,46.5,16.1,46.5,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1,17.9L1,17.9C1,17.8,1,17.9,1,17.9L1,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47,17.8L47,17.8L47,17.8C47,17.9,47,17.8,47,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0.9,30.1C1,30.1,1,30.2,0.9,30.1L0.9,30.1L0.9,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M47,30.2C47,30.2,47,30.1,47,30.2L47,30.2L47,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1.5,31.8C1.5,31.8,1.5,31.9,1.5,31.8L1.5,31.8L1.5,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.5,31.9C46.5,31.9,46.5,31.8,46.5,31.9L46.5,31.9L46.5,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M4.8,38.1C4.8,38.1,4.8,38.1,4.8,38.1C4.8,38.1,4.8,38.1,4.8,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.2,38.1C43.2,38.1,43.2,38.1,43.2,38.1C43.2,38.1,43.2,38.1,43.2,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M9.9,43.2C9.9,43.2,9.9,43.2,9.9,43.2C9.9,43.2,9.9,43.2,9.9,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.1,43.2C38.1,43.2,38.1,43.2,38.1,43.2C38.1,43.2,38.1,43.2,38.1,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.1,46.5C16.1,46.5,16.2,46.5,16.1,46.5L16.1,46.5L16.1,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.8,46.5C31.8,46.5,31.9,46.5,31.8,46.5L31.8,46.5L31.8,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M17.8,47C17.8,47,17.9,47,17.8,47L17.8,47L17.8,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M30.1,47.1C30.1,47,30.2,47,30.1,47.1L30.1,47.1L30.1,47.1z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_729ec6d6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M17.4,1.1L17.4,1.1C17.4,1.1,17.4,1.1,17.4,1.1L17.4,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.6,1.1L30.6,1.1L30.6,1.1C30.6,1.1,30.6,1.1,30.6,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1.1,17.4L1.1,17.4C1.1,17.4,1.1,17.4,1.1,17.4L1.1,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.9,17.4L46.9,17.4L46.9,17.4C46.9,17.4,46.9,17.4,46.9,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1.1,30.6C1.1,30.6,1.1,30.6,1.1,30.6L1.1,30.6L1.1,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.9,30.6C46.9,30.6,46.9,30.6,46.9,30.6L46.9,30.6L46.9,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M17.4,46.9C17.4,46.9,17.4,46.9,17.4,46.9L17.4,46.9L17.4,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M30.6,46.9C30.6,46.9,30.6,46.9,30.6,46.9L30.6,46.9L30.6,46.9z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_6888a5b0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16.7,1.3L16.7,1.3C16.7,1.3,16.7,1.3,16.7,1.3L16.7,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31.3,1.3L31.3,1.3L31.3,1.3C31.3,1.3,31.3,1.3,31.3,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M11.7,3.6C11.7,3.6,11.7,3.6,11.7,3.6C11.7,3.6,11.7,3.6,11.7,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M36.3,3.6C36.3,3.6,36.3,3.6,36.3,3.6C36.3,3.6,36.3,3.6,36.3,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3.6,11.7C3.6,11.7,3.6,11.7,3.6,11.7C3.6,11.7,3.6,11.7,3.6,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.4,11.7C44.4,11.7,44.4,11.7,44.4,11.7C44.4,11.7,44.4,11.7,44.4,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1.3,16.7L1.3,16.7C1.3,16.7,1.3,16.7,1.3,16.7L1.3,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M46.7,16.7L46.7,16.7L46.7,16.7C46.7,16.7,46.7,16.7,46.7,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1.3,31.3C1.3,31.3,1.3,31.3,1.3,31.3L1.3,31.3L1.3,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M46.7,31.3C46.7,31.3,46.7,31.3,46.7,31.3L46.7,31.3L46.7,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3.6,36.3C3.6,36.3,3.6,36.3,3.6,36.3C3.6,36.3,3.6,36.3,3.6,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.4,36.3C44.4,36.3,44.4,36.3,44.4,36.3C44.4,36.3,44.4,36.3,44.4,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M11.7,44.4C11.7,44.4,11.7,44.4,11.7,44.4C11.7,44.4,11.7,44.4,11.7,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M36.3,44.4C36.3,44.4,36.3,44.4,36.3,44.4C36.3,44.4,36.3,44.4,36.3,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16.7,46.7C16.7,46.7,16.7,46.7,16.7,46.7L16.7,46.7L16.7,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31.3,46.7C31.3,46.7,31.3,46.7,31.3,46.7L31.3,46.7L31.3,46.7z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_6e93b6c3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.5,1.4L16.5,1.4C16.5,1.4,16.5,1.4,16.5,1.4L16.5,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.4,1.3L31.4,1.3L31.4,1.3C31.5,1.4,31.5,1.3,31.4,1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.3,1.4L16.3,1.4C16.3,1.4,16.3,1.4,16.3,1.4L16.3,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.6,1.4L31.6,1.4L31.6,1.4C31.7,1.4,31.7,1.4,31.6,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1.4,16.3L1.4,16.3C1.4,16.3,1.4,16.3,1.4,16.3L1.4,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.6,16.3L46.6,16.3L46.6,16.3C46.6,16.3,46.6,16.3,46.6,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1.4,16.5L1.4,16.5C1.4,16.5,1.4,16.5,1.4,16.5L1.4,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.6,16.5L46.6,16.5L46.6,16.5C46.7,16.5,46.6,16.5,46.6,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1.3,31.4C1.4,31.5,1.4,31.5,1.3,31.4L1.3,31.4L1.3,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.6,31.5C46.6,31.5,46.6,31.5,46.6,31.5L46.6,31.5L46.6,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1.4,31.6C1.4,31.7,1.4,31.7,1.4,31.6L1.4,31.6L1.4,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M46.6,31.7C46.6,31.7,46.6,31.7,46.6,31.7L46.6,31.7L46.6,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.3,46.6C16.3,46.6,16.3,46.6,16.3,46.6L16.3,46.6L16.3,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.6,46.6C31.7,46.6,31.7,46.6,31.6,46.6L31.6,46.6L31.6,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M16.5,46.6C16.5,46.6,16.5,46.6,16.5,46.6L16.5,46.6L16.5,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.4,46.7C31.5,46.6,31.5,46.6,31.4,46.7L31.4,46.7L31.4,46.7z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_71a2cddd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M14.6,2.1L14.6,2.1C14.6,2.1,14.6,2.1,14.6,2.1L14.6,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M33.3,2.1L33.3,2.1L33.3,2.1C33.4,2.1,33.4,2.1,33.3,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10.5,4.3C10.5,4.3,10.6,4.3,10.5,4.3C10.6,4.3,10.5,4.3,10.5,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M37.4,4.3C37.4,4.3,37.5,4.3,37.4,4.3C37.5,4.3,37.4,4.3,37.4,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4.3,10.6L4.3,10.6C4.3,10.5,4.3,10.6,4.3,10.6L4.3,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M43.7,10.5L43.7,10.5L43.7,10.5C43.7,10.6,43.7,10.5,43.7,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2.1,14.6L2.1,14.6C2.1,14.6,2.1,14.6,2.1,14.6L2.1,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M45.9,14.6L45.9,14.6L45.9,14.6C45.9,14.6,45.9,14.6,45.9,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2.1,33.3C2.1,33.4,2.1,33.4,2.1,33.3L2.1,33.3L2.1,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M45.9,33.4C45.9,33.4,45.9,33.4,45.9,33.4L45.9,33.4L45.9,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4.3,37.4C4.3,37.4,4.3,37.5,4.3,37.4L4.3,37.4L4.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M43.7,37.5C43.7,37.5,43.7,37.4,43.7,37.5C43.7,37.4,43.7,37.5,43.7,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10.5,43.7C10.5,43.7,10.6,43.7,10.5,43.7C10.6,43.7,10.5,43.7,10.5,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M37.4,43.7C37.4,43.7,37.5,43.7,37.4,43.7L37.4,43.7L37.4,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M14.6,45.9C14.6,45.9,14.6,45.9,14.6,45.9L14.6,45.9L14.6,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M33.3,45.9C33.4,45.9,33.4,45.9,33.3,45.9L33.3,45.9L33.3,45.9z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_627f98a2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M14.1,2.3C14.2,2.3,14.2,2.3,14.1,2.3C14.2,2.3,14.2,2.3,14.1,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M33.8,2.3C33.8,2.3,33.8,2.3,33.8,2.3C33.8,2.3,33.8,2.3,33.8,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2.3,14.2C2.3,14.2,2.3,14.2,2.3,14.2C2.3,14.2,2.3,14.2,2.3,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M45.7,14.1C45.7,14.2,45.7,14.2,45.7,14.1C45.7,14.2,45.7,14.2,45.7,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M2.3,33.8C2.3,33.8,2.3,33.8,2.3,33.8C2.3,33.8,2.3,33.8,2.3,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M45.7,33.9C45.7,33.8,45.7,33.8,45.7,33.9C45.7,33.8,45.7,33.8,45.7,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M14.1,45.7C14.2,45.7,14.2,45.7,14.1,45.7C14.2,45.7,14.2,45.7,14.1,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M33.8,45.7C33.8,45.7,33.8,45.7,33.8,45.7C33.8,45.7,33.8,45.7,33.8,45.7z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_71a2d0e0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M14,2.3L14,2.3L14,2.3L14,2.3L14,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M33.9,2.3L33.9,2.3L33.9,2.3C34,2.3,33.9,2.3,33.9,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M37,4L37,4L37,4C37.1,4.1,37,4,37,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M4,10.9L4,10.9C4.1,10.9,4,11,4,10.9L4,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M43.9,10.9L43.9,10.9L43.9,10.9C44,11,43.9,10.9,43.9,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2.3,14L2.3,14L2.3,14L2.3,14L2.3,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M45.7,14L45.7,14L45.7,14L45.7,14L45.7,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2.3,33.9C2.3,33.9,2.3,34,2.3,33.9L2.3,33.9L2.3,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M45.7,33.9L45.7,33.9L45.7,33.9L45.7,33.9L45.7,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M4,37C4,37,4.1,37.1,4,37L4,37L4,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M43.9,37.1C43.9,37.1,44,37,43.9,37.1L43.9,37.1L43.9,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M10.9,43.9C10.9,43.9,11,44,10.9,43.9L10.9,43.9L10.9,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M37,44C37,44,37.1,43.9,37,44L37,44L37,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M14,45.7L14,45.7L14,45.7L14,45.7L14,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M33.9,45.7L33.9,45.7L33.9,45.7L33.9,45.7L33.9,45.7z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_6d91b1bd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M11.1,3.9C11.1,3.9,11.2,3.9,11.1,3.9C11.2,3.9,11.1,3.9,11.1,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M36.8,3.9C36.8,3.9,36.9,3.9,36.8,3.9C36.9,3.9,36.8,3.9,36.8,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3.9,11.2C3.9,11.2,3.9,11.1,3.9,11.2C3.9,11.1,3.9,11.2,3.9,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M44.1,11.1L44.1,11.1L44.1,11.1C44.1,11.2,44.1,11.1,44.1,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3.9,36.8C3.9,36.8,3.9,36.9,3.9,36.8C3.9,36.9,3.9,36.8,3.9,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M44.1,36.9C44.1,36.9,44.1,36.8,44.1,36.9C44.1,36.8,44.1,36.9,44.1,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M11.1,44.1C11.1,44.1,11.2,44.1,11.1,44.1L11.1,44.1L11.1,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M36.8,44.1C36.8,44.1,36.9,44.1,36.8,44.1C36.9,44.1,36.8,44.1,36.8,44.1z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_698ba9b4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M9.6,5C9.6,5,9.6,5,9.6,5C9.6,5,9.6,5,9.6,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M38.3,5L38.3,5L38.3,5C38.4,5,38.4,5,38.3,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M5,9.6C5,9.6,5,9.6,5,9.6C5,9.6,5,9.6,5,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M43,9.6C43,9.6,43,9.6,43,9.6C43,9.6,43,9.6,43,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M5,38.4C5,38.4,5,38.4,5,38.4C5,38.4,5,38.4,5,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M43,38.4C43,38.4,43,38.4,43,38.4L43,38.4L43,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M9.6,43C9.6,43,9.6,43,9.6,43C9.6,43,9.6,43,9.6,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M38.4,43C38.4,43,38.4,43,38.4,43C38.4,43,38.4,43,38.4,43z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_709ac1cf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M8.6,5.8L8.6,5.8C8.7,5.7,8.6,5.8,8.6,5.8L8.6,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M39.3,5.7C39.3,5.7,39.4,5.8,39.3,5.7C39.4,5.8,39.3,5.7,39.3,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M5.7,8.7C5.8,8.7,5.8,8.6,5.7,8.7C5.8,8.6,5.8,8.7,5.7,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M42.2,8.6C42.2,8.6,42.2,8.7,42.2,8.6C42.2,8.7,42.2,8.6,42.2,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M5.7,39.3C5.7,39.3,5.8,39.4,5.7,39.3L5.7,39.3L5.7,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M42.2,39.4C42.2,39.4,42.3,39.3,42.2,39.4C42.3,39.3,42.2,39.4,42.2,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M8.6,42.2C8.6,42.2,8.7,42.2,8.6,42.2C8.7,42.2,8.6,42.2,8.6,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M39.3,42.3C39.3,42.2,39.4,42.2,39.3,42.3C39.4,42.2,39.3,42.2,39.3,42.3z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_4683bbce"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M41.8,8.1c0.1,0.1,0.1,0.1,0.2,0.2C41.8,8.3,41.7,8.2,41.8,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M39.7,41.8c0,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2C39.7,41.9,39.7,41.8,39.7,41.8z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_6ea5d6e8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M43.8,10.7L43.8,10.7L43.8,10.7C43.8,10.8,43.8,10.7,43.8,10.7z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_5990c2d5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M24.6,47.9c0.1-0.1,0.3-0.1,0.4,0l0,0H24.6z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 24,
    cy: 24,
    r: 23.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 24,
    cy: 24.3,
    r: 22.8
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "st19",
    d: "M24.2,27.3c4,0,7.3-4.1,7.3-9.1c0-5.1-1-9.1-7.3-9.1s-7.3,4.1-7.3,9.1S20.2,27.3,24.2,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    className: "st19",
    d: "M10.6,41.2C10.6,40.8,10.6,41,10.6,41.2L10.6,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_122",
    className: "st19",
    d: "M37.8,41.4C37.8,41.2,37.8,40.8,37.8,41.4L37.8,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_123",
    className: "st19",
    d: "M37.8,40.8c-0.1-8.7-1.3-11.3-9.7-12.8c0,0-1.1,1.5-4,1.5s-4-1.5-4-1.5 c-8.4,1.5-9.5,4-9.7,12.6c0,0.7,0,0.7,0,0.7c0,0.1,0,0.8,0,1.3c0,0,2,4.6,13.5,4.6c11.7,0,13.7-4.4,13.7-4.4c0-0.3,0-1.1,0-1.3 S37.8,41.2,37.8,40.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotFound);
export default __webpack_public_path__ + "static/media/user_not_found.e75d3ffe774242004bb2ecd3a3d5d553.svg";
export { ForwardRef as ReactComponent };